import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CheckIcon } from 'lucide-react';
import { SiteLogo } from '../components/SiteLogo';
import { WeddingVideos } from '../components/thankyou/WeddingVideos';
import { ReviewsWall } from '../components/thankyou/ReviewsWall';
import { FollowUs } from '../components/thankyou/FollowUs';
import { BrochureViewer } from '../components/thankyou/BrochureViewer';
export function ThankYou() {
  useEffect(() => {
    document.title = 'You’re confirmed — Twenty Mile House';
  }, []);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-134" data-mp="2xpo9y8oml5gr">
      <header className="relative flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-135" data-mp="32hxu18327bb4">
        <SiteLogo size="sm" data-id="element-136" data-mp="37hk9lo6d13n3" />
        <Link to="/bay-area" className="absolute right-6 font-sans text-[10px] font-medium uppercase tracking-[0.25em] text-ink/60 transition-colors duration-150 hover:text-ink md:right-10" data-id="element-137" data-mp="37gsl0xb6k66b">
          Return to site
        </Link>
      </header>

      <main data-id="element-138" data-mp="286xjitn6gbmh">
        <section className="mx-auto max-w-xl px-6 pt-12 text-center" data-id="element-139" data-mp="286paxdy37sh3">
          <span className="mx-auto flex h-11 w-11 items-center justify-center rounded-full border border-gold/50 bg-notice" data-id="element-140" data-mp="236jn68uxuq4a">
            <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-141" data-mp="1y8hvx0nczkhq" />
          </span>
          <h1 className="mt-5 font-heading text-2xl font-light uppercase leading-[1.2] tracking-[0.06em] text-logo md:text-[2.2rem]" data-id="element-142" data-mp="1u769f3zs7fdr">
            You’re booked!
          </h1>
          <p className="mx-auto mt-4 max-w-md font-body text-[15px] leading-relaxed text-ink/70" data-id="element-143" data-mp="2lwsprjun0jwi">
            Thank you for scheduling a virtual tour with Twenty Mile House! Your confirmation email
            has your calendar invite and a link to reschedule if needed.
          </p>
        </section>

        <BrochureViewer data-id="element-144" data-mp="39n54bdke1ew2" />

        <div className="mt-16" data-id="element-145" data-mp="39nokaoqh9t7g">
          <WeddingVideos data-id="element-146" data-mp="39oq016ifv3vi" />
          <ReviewsWall data-id="element-147" data-mp="34vn2yoegdcak" />
          <FollowUs data-id="element-148" data-mp="34v3tzx6s5y8o" />
        </div>
      </main>
    </div>;
}